import { Directory } from "@/type";
import { isDir } from "./path";

export default function selectedFile(directory: Directory): string {
  const _bak = [...directory];
  while (_bak.length > 0) {
    const dir = _bak.pop();
    if (!isDir(dir?.key as string)) {
      return dir?.key as string;
    }
    _bak.unshift(...(dir?.children || []));
  }
  return "";
}
